<template>
	<div class="hm_page">
		<div class="pc_box" v-if="!isPhone">
			<div class="en_swiper">
				<swiper class="swiper_box11" :options="swiperOption59" ref="mySwiperA" @slideChange="onSlideChange55"
					v-if="swiperList1.length">
					<swiper-slide class="swiper_item flex2" v-if="videoobj.file">
						<div class="vid_box flex2">
							<video ref="videoPlayer" preload="metadata" :autoplay="isauto" :muted="ismute" :src="staticImg+videoobj.file"
								@ended="onVideoEnded"></video>
						</div>
					</swiper-slide>
					<swiper-slide class="swiper_item flex2" v-for="(item, index) in swiperList1" :key="index">
						<div class="img_box">
							<img :src="staticImg + item.image" />
						</div>
					</swiper-slide>
				</swiper>
				<div class="sp_line"></div>
				<div class="sp_suolue flex3">
					<div class="ss_box1 flex1">
						<div class="sb1_left">
							<img class="sb1_left_img1" :src="staticImg+swiperList1[spcurrent].images">
							<div class="sb1_left_img2" @click="jingYin" v-if="swiperList1[spcurrent].file!=''">
								<img src="@/images/home/aud1.png">
								<span v-if="ismute"></span>
							</div>
						</div>
						<div class="sb1_right">0{{spcurrent+1}}.</div>
					</div>
					<div class="ss_box2 flex3">
						<img @click="swiperChange(1)" src="@/images/home/bn_left.png">
						<div>
							<span v-for="(item,index) in swiperList1.length" :key="item.id"
								:class="spcurrent==(index)?'sp_act6':''"></span>
						</div>
						<img @click="swiperChange(2)" src="@/images/home/bn_right.png">
					</div>
				</div>
			</div>
			<div class="mill_box flex3">
				<div class="ml_left">
					<div class="hd_img">
						<img src="@/images/home/fh.png">
						<p>Product</p>
					</div>
					<ul class="bj_list">
						<li class="bj_item" @mouseenter="hoverSty(index)" @mouseleave="hovcurt=''" :class="hovcurt===index?'gd_act':''"
							@click="goodChange(index)" v-for="(item,index) in gdlist" :key="item.id">
							<div class="bjt_con" :class="actcurt===index?'gd_act':''">
								<p class="bjt_name">{{item.name}}</p>
								<p class="bjt_line"></p>
							</div>
						</li>
					</ul>
				</div>
				<div class="ml_mid">
					<img v-if="actgd.image2" data-aos="zoom-in" :src="staticImg+actgd.image2">
				</div>
				<div class="ml_right" v-if="actgd.name">
					<p class="mrt_p1" data-aos="fade-right">{{actgd.name}}</p>
					<p class="mrt_p2" data-aos="fade-up">Product Introduction</p>
					<p class="mrt_p3" data-aos="fade-up">{{actgd.description}}</p>
					<p class="mrt_p2" data-aos="fade-up">Net content：</p>
					<p class="mrt_p3" data-aos="fade-up">{{actgd.netcon}}</p>
					<p class="mrt_p2" data-aos="fade-up">Alcohol by volume：</p>
					<p class="mrt_p3" data-aos="fade-up">{{actgd.volume}}</p>
					<div class="mrt_p4" data-aos="fade-up">
						<img @click="toProductDetail(actgd.id)" src="@/images/home/hmore.png">
					</div>
				</div>
			</div>
			<!-- <div class="mj_list flex3">
				<div class="mj_item" v-for="(item,index) in mjlist" :key="index" @mouseenter="moveIn(index)" @mouseleave="moveOut">
					<img class="mt_zt" :src="staticImg+item.image">
					<div class="mt_zhe animate__animated" :class="moveAct===index?'zhe_zhao':''">
						<div class="zz_text">
							<p class="zz_p1">{{item.title}}</p>
							<p class="zz_p2 animate__animated" :class="moveAct===index?'animate__fadeInUp':'animate__fadeOutDown'">
								{{item.jieshao}}</p>
						</div>
					</div>
					<div class="zz_tmg animate__animated flex2" :class="moveAct===index?'zhe_zhao':''">
						<img class="animate__animated" :class="moveAct===index?'animate__fadeIn':'animate__fadeOut'"
							src="@/images/home/lazhu.png">
					</div>
				</div>
			</div> -->
		</div>
		<div class="ph_home" v-if="isPhone">
			<enHeader2 :searchShow="true"></enHeader2>
			<div class="swiper4">
				<swiper class="swiper_box3" :options="swiperOption35" ref="mySwiper3">
					<swiper-slide class="swiper_item3 flex2" v-for="(item, index) in swiperList2" :key="index">
						<div class="img_box3">
							<img :src="staticImg+item.image" />
						</div>
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div class="mill_box2">
				<div class="hd_img">
					<img src="@/images/home/fh.png">
					<p>Product</p>
				</div>
				<ul class="bj_list flex1">
					<li class="bj_item" @mouseenter="hoverSty(index)" @mouseleave="hovcurt=''" :class="hovcurt===index?'gd_act':''"
						@click="goodChange(index)" v-for="(item,index) in gdlist" :key="item.id">
						<div class="bjt_con">
							<img v-if="index==0" :src="actcurt==0?ku1_act:ku1">
							<img v-if="index==1" :src="actcurt==1?ku1_act:ku1">
							<img v-if="index==2" :src="actcurt==2?ku1_act:ku1">
							<img v-if="index==3" :src="actcurt==3?ku1_act:ku1">
							<img v-if="index==4" :src="actcurt==4?ku5_act:ku5">
							<p class="bjt_name flex2" :class="actcurt===index?'gd_act2':''">{{item.name}}</p>
						</div>
					</li>
				</ul>
				<div class="ml_mid" style="min-height: 300px;">
					<img v-if="actgd.image2" data-aos="fade-up" :src="staticImg+actgd.image2">
				</div>
				<div class="ml_right" style="min-height: 400px;">
					<div v-if="actgd.name" data-aos="fade-up">
						<p class="mrt_p1">{{actgd.name}}</p>
						<p class="mrt_p2">Product Introduction</p>
						<p class="mrt_p3">{{actgd.description}}</p>
						<p class="mrt_p2">Net content：</p>
						<p class="mrt_p3">{{actgd.netcon}}</p>
						<p class="mrt_p2">Alcohol by volume：</p>
						<p class="mrt_p3">{{actgd.volume}}</p>
						<div class="mrt_p4">
							<img @click="toProductDetail(actgd.id)" src="@/images/home/hmore.png">
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="mj_list">
				<div class="mj_item" v-for="(item,index) in mjlist" :key="index">
					<img class="zz_tmg flex2" src="@/images/home/lazhu.png">
					<div class="zz_text">
						<p class="zz_p1">{{item.title}}</p>
						<p class="zz_p2">{{item.jieshao}}</p>
					</div>
					<img class="mt_zt" :src="staticImg+item.image">
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentIndex: 0,
			swiperOption59: {
				initialSlide: 0, // 初始显示第一个（视频）
				loop: false, // 禁用循环，避免索引错乱
				speed: 1000, //切换速度
				mousewheel: false,
			},
			swiperOption35: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				mousewheel: true,
				// loop: true, //开启循环
				speed: 1000, //切换速度
				autoplay: true,
			},
			ismute: false,
			isauto: false,
			videoobj: {},
			swiperList1: [],//pc端轮播图
			spcurrent: 0,//pc端轮播图激活项
			swiperList2: [],
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
			mlcurt: 1,//1Brew  2Nature  3Inherit
			mjlist: [],
			moveAct: "",
			gdlist: [],
			actgd: {},
			actcurt: 0,
			hovcurt: '',
			ku1: require("@/images/home/ku1.png"),
			ku1_act: require("@/images/home/ku1_act.png"),
			ku5: require("@/images/home/ku5.png"),
			ku5_act: require("@/images/home/ku5_act.png"),
		}
	},
	computed: {
		swiper22() {
			return this.$refs.mySwiperA.$swiper;
		}
	},
	mounted() {
		this.isauto = true;
	},
	created() {
		this.enBanner();
		this.liquor();
		this.productxl();
	},
	methods: {
		// 商品列表，英文只有5款商品
		async productxl() {
			const res = await this.$api.enProductlist({
				product_id: '',
			});
			// console.log(999,res);
			if (res.code == 1) {
				this.gdlist = res.data;
				this.actgd = this.gdlist[0];
			}
		},
		goodChange(index) {
			this.actcurt = index;
			this.actgd = {};
			setTimeout(() => {
				this.actgd = this.gdlist[index];
			}, 50);
		},
		hoverSty(index) {
			this.hovcurt = index;
		},
		jingYin() {
			this.ismute = !this.ismute;
		},
		// 轮播图
		async enBanner() {
			const res = await this.$api.enBanner();
			if (res.code == 1) {
				var data3 = res.data;
				for (let i = 0; i < data3.length; i++) {
					if (data3[i].type == 1) {//电脑端
						this.swiperList1.push(data3[i]);
						// console.log('轮播图',this.swiperList1);
						if (data3[i].file != '') {
							this.videoobj = data3[i];
						}
					}
					if (data3[i].type == 2) {//手机端
						this.swiperList2.push(data3[i]);
					}
				}
			}
		},
		// 首页名酒
		async liquor() {
			const res = await this.$api.liquor();
			if (res.code == 1) {
				this.mjlist = res.data;
			}
		},
		// 轮播图切换
		async onSlideChange55() {
			const currentIndex = this.swiper22.realIndex;
			this.spcurrent = currentIndex;
			var vids = await this.$refs.videoPlayer;
			if (currentIndex == 0) {
				this.isauto = true;
				this.swiper22.autoplay.stop();
				this.$nextTick(() => {
					vids.play();
					this.$forceUpdate();
				});
			} else {
				this.swiper22.autoplay.start();
				vids.pause();
			}
		},
		onVideoEnded() {
			this.swiper22.slideNext();
			this.swiper22.autoplay.start();
		},
		muteChange() {
			this.ismute = !this.ismute;
			this.isauto = !this.isauto;
		},
		swiperChange(a) {
			if (a == 1) {
				if (this.spcurrent > 0) {
					this.spcurrent--;
					this.swiper22.slideTo(this.spcurrent);
				}
			}
			if (a == 2) {
				if (this.spcurrent < (this.swiperList1.length - 1)) {
					this.spcurrent++;
					this.swiper22.slideTo(this.spcurrent);
				}
			}
		},
		moveOut() {
			this.moveAct = "";
		},
		moveIn(a) {
			this.moveAct = a;
		},
		toProductDetail(id) {
			this.$router.push("/en/productDetail?gid=" + id);
		},
	},
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.sp_act6 {
	background-color: #fff !important;
}
.ml_act {
	color: #c4a156 !important;
	font-size: 35px !important;
}
.ml_act11 {
	color: #c4a156 !important;
	font-size: 30px !important;
}
.ml_act2 {
	color: #c4a156 !important;
}
.zhe_zhao {
	background-color: #79191c !important;
	opacity: 0.85 !important;
}
.gd_act {
	color: #d43236 !important;
	.bjt_line {
		width: 100% !important;
	}
	.bjt_name {
		font-weight: bold;
	}
}
.gd_act2 {
	color: #d43236 !important;
	font-weight: bold !important;
}
.hm_page {
	@font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	.pc_box {
		background-image: url("../../../images/bgimg3.png");
		min-width: 900px;
		.en_swiper {
			position: relative;
			.swiper_box11 {
				width: 100%;
				height: vw(1080);
				.swiper_item {
					width: 100%;
					height: vw(1080);
					.vid_box {
						background-color: #000;
						position: relative;
						width: 100%;
						height: vw(1080);
						video {
							width: 100%;
							height: vw(1080);
						}
					}
					.img_box {
						width: 100%;
						height: vw(1080);
						img {
							width: 100%;
							height: vw(1080);
						}
					}
				}
			}
			.sp_line {
				position: absolute;
				left: 0;
				bottom: 74px;
				z-index: 999;
				height: 1px;
				width: 1200px;
				background-color: #ffebc4;
				opacity: 0.3;
			}
			.sp_suolue {
				position: absolute;
				left: 40px;
				bottom: 95px;
				z-index: 99;
				align-items: flex-end;
				.ss_box1 {
					width: 300px;
					height: 160px;
					border-radius: 10px;
					background-color: rgba(62, 33, 12, 0.3);
					padding: 20px;
					box-sizing: border-box;
					align-items: flex-start;
					.sb1_left {
						display: flex;
						align-items: flex-end;
						.sb1_left_img1 {
							width: 120px;
							height: 120px;
							border-radius: 10px;
						}
						.sb1_left_img2 {
							position: relative;
							cursor: pointer;
							margin-left: 20px;
							img {
								width: 32px;
								height: 32px;
							}
							span {
								position: absolute;
								left: 16px;
								top: 0;
								z-index: 99;
								transform: rotate(-45deg);
								width: 1px;
								height: 30px;
								background-color: #ffebc4;
							}
						}
					}
					.sb1_right {
						margin-left: 50px;
						font-size: 28px;
						color: #ffebc4;
					}
				}
				.ss_box2 {
					margin-left: 30px;
					img {
						width: 32px;
						height: 32px;
						cursor: pointer;
					}
					div {
						margin: 0 12px 0 8px;
						span {
							display: inline-block;
							width: 8px;
							height: 8px;
							border-radius: 8px;
							background-color: #a09997;
							margin-left: 4px;
						}
					}
				}
			}
		}
		.mill_box {
			min-width: 900px;
			min-height: 506px;
			height: 950px;
			box-sizing: border-box;
			padding: 40px 60px;
			background-image: url("../../../images/home/mlbg.png");
			background-size: 100% 100%;
			background-repeat: no-repeat;
			align-items: flex-start;
			.ml_left {
				width: 490px;
				.hd_img {
					text-align: left;
					img {
						width: 145px;
					}
					p {
						color: #c4a156;
						font-size: 40px;
						font-weight: bold;
						margin-top: 60px;
					}
				}
				.bj_list {
					margin-top: 30px;
					.bj_item {
						font-size: 20px;
						text-align: left;
						cursor: pointer;
						position: relative;
						.bjt_con {
							padding: 30px 0;
							display: inline-block;
							position: relative;
							.bjt_name {
								font-size: 20px;
							}
							.bjt_line {
								position: absolute;
								left: 0;
								bottom: 0;
								width: 0;
								z-index: 1;
								transition: width 0.5s ease;
								height: 2px;
								background-color: #d43236;
							}
						}
					}
				}
			}
			.ml_mid {
				width: 660px;
				padding-top: 100px;
				img {
					width: 100%;
					transition: transform 0.8s ease;
					&:hover {
						transform: scale(1.06);
					}
				}
			}
			.ml_right {
				width: 629px;
				margin-left: 80px;
				text-align: left;
				overflow: hidden;
				padding-top: 90px;
				.mrt_p1 {
					font-size: 60px;
					line-height: 1.6;
					font-weight: bold;
					width: 550px;
				}
				.mrt_p2 {
					font-size: 20px;
					font-weight: bold;
					margin-top: 35px;
				}
				.mrt_p3 {
					font-size: 16px;
					margin-top: 20px;
					line-height: 1.65;
				}
				.mrt_p4 {
					margin-top: 40px;
					img {
						width: 90px;
						cursor: pointer;
					}
				}
			}
		}
		.mj_list {
			flex-wrap: wrap;
			.mj_item {
				width: 33.33%;
				position: relative;
				cursor: pointer;
				.mt_zt {
					width: 100%;
					display: block;
				}
				.zz_tmg {
					position: absolute;
					z-index: 10;
					left: 0;
					bottom: calc(50% + 30px);
					right: 0;
					top: 0;
					background-color: rgba(0, 0, 0, 0.7);
					img {
						width: 30%;
						height: auto;
					}
				}
				.mt_zhe {
					display: flex;
					justify-content: center;
					align-content: flex-start;
					flex-wrap: wrap;
					position: absolute;
					z-index: 10;
					left: 0;
					top: calc(50% - 30px);
					right: 0;
					bottom: 0;
					background-color: rgba(0, 0, 0, 0.7);
					.zz_text {
						width: 100%;
						.zz_p1 {
							width: 100%;
							font-size: 44px;
							color: #f8f3d5;
						}
						.zz_p2 {
							width: 60%;
							margin: 0 auto;
							font-size: 20px;
							line-height: 30px;
							margin-top: 20px;
							color: #f8f3d5;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.pc_box {
			.mj_list {
				.mj_item {
					.mt_zhe {
						.zz_text {
							width: 100%;
							.zz_p1 {
								width: 100%;
								font-size: 35px;
								color: #f8f3d5;
							}
							.zz_p2 {
								width: 60%;
								margin: 0 auto;
								font-size: 18px;
								line-height: 30px;
								margin-top: 15px;
								color: #f8f3d5;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1500px) {
		.pc_box {
			.mill_box {
				.ml_left {
					.bj_list {
						.bj_item {
							.bjt_con {
								padding: 25px 0;
							}
						}
					}
				}
				.ml_right {
					margin-left: 50px;
					.mrt_p1 {
						font-size: 40px;
						line-height: 1.5;
						width: 100%;
					}
					.mrt_p3 {
						line-height: 1.6;
					}
				}
			}
			.mj_list {
				.mj_item {
					.mt_zhe {
						.zz_text {
							width: 100%;
							.zz_p1 {
								width: 100%;
								font-size: 35px;
								color: #f8f3d5;
							}
							.zz_p2 {
								width: 60%;
								margin: 0 auto;
								font-size: 18px;
								line-height: 30px;
								margin-top: 15px;
								color: #f8f3d5;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.pc_box {
			.en_swiper {
				.sp_line {
					width: 800px;
				}
			}
			.mj_list {
				.mj_item {
					.mt_zhe {
						.zz_text {
							width: 100%;
							.zz_p1 {
								width: 100%;
								font-size: 28px;
								color: #f8f3d5;
							}
							.zz_p2 {
								width: 80%;
								margin: 0 auto;
								font-size: 16px;
								line-height: 30px;
								margin-top: 15px;
								color: #f8f3d5;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.pc_box {
			.mill_box {
				.ml_left {
					.bj_list {
						.bj_item {
							.bjt_con {
								padding: 20px 0;
							}
						}
					}
				}
				.ml_right {
					margin-left: 40px;
					.mrt_p1 {
						font-size: 35px;
						line-height: 1.5;
						width: 100%;
					}
					.mrt_p2 {
						margin-top: 20px;
					}
					.mrt_p3 {
						line-height: 1.5;
					}
					.mrt_p4 {
						margin-top: 20px;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.pc_box {
			.mj_list {
				.mj_item {
					.mt_zhe {
						.zz_text {
							width: 100%;
							.zz_p1 {
								width: 100%;
								font-size: 24px;
								color: #f8f3d5;
							}
							.zz_p2 {
								width: 85%;
								margin: 0 auto;
								font-size: 15px;
								line-height: 20px;
								margin-top: 15px;
								color: #f8f3d5;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 900px) {
		.pc_box {
			.en_swiper {
				.swiper_box11 {
					height: 506px;
					.swiper_item {
						height: 506px;
						.vid_box {
							height: 506px;
							video {
								height: 506px;
							}
						}
						.img_box {
							height: 506px;
							img {
								height: 506px;
							}
						}
					}
				}
			}
		}
	}
	.ph_home {
		padding-top: 1.23rem;
		background-image: url("../../../images/bgimg3.png");
		.swiper4 {
			.swiper_box3 {
				.swiper-pagination-bullet-active {
					opacity: 1;
					background: #fff;
				}
				.swiper_item3 {
					.img_box3 {
						width: 100%;
						img {
							width: 100%;
							display: block;
						}
					}
				}
			}
		}
		.mill_box2 {
			box-sizing: border-box;
			padding: 1.46rem 0.5rem;
			background-image: url("../../../images/home/pbg1.png");
			background-size: cover;
			background-repeat: no-repeat;
			.hd_img {
				img {
					width: 1.82rem;
				}
				p {
					font-size: 0.5rem;
					color: #c4a156;
					font-weight: bold;
					margin-top: 0.3rem;
				}
			}
			.bj_list {
				margin-top: 1.17rem;
				flex-wrap: wrap;
				.bj_item {
                    width: 49.5%;
					position: relative;
					margin-bottom: 0.5rem;
                    &:nth-last-child(1){
                        width: 100%;
                    }
					.bjt_con {
						display: inline-block;
                        width: 100%;
						position: relative;
						img {
							width: 100%;
							height: 0.9rem;
						}
						.bjt_name {
							position: absolute;
							left: 0;
							top: 0;
							bottom: 5px;
							right: 0;
							z-index: 1;
							font-size: 0.34rem;
						}
					}
				}
			}
			.ml_mid {
				margin-top: 0.6rem;
				padding: 0 0.24rem;
				img {
					width: 100%;
				}
			}
			.ml_right {
				padding-top: 0.8rem;
				.mrt_p1 {
					font-size: 0.68rem;
					line-height: 1.6;
					font-weight: bold;
				}
				.mrt_p2 {
					font-size: 0.39rem;
					font-weight: bold;
					margin-top: 1rem;
				}
				.mrt_p3 {
					font-size: 0.36rem;
					margin-top: 0.4rem;
					line-height: 1.65;
					text-align: left;
				}
				.mrt_p4 {
					margin-top: 1rem;
					img {
						width: 2.19rem;
					}
				}
			}
		}
		.mj_list {
			.mj_item {
				margin-top: 0.73rem;
				.zz_tmg {
					width: 2.43rem;
					margin: 0 auto;
				}
				.zz_text {
					margin-top: 0.35rem;
					.zz_p1 {
						font-size: 0.5rem;
						color: #1a1a1a;
					}
					.zz_p2 {
						font-size: 0.34rem;
						margin-top: 0.2rem;
						color: #666666;
						padding: 0 0.85rem;
					}
				}
				.mt_zt {
					width: 100%;
					display: block;
					margin-top: 0.5rem;
				}
			}
		}
	}
}
</style>